import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";

import "./Contact.scss";





const detail = [
  {
    title: "Office Address : ",
    detail: "Address Here",
  },
  {
    title: "Service Department Address : ",
    detail: "Address Here",
  },
  {
    title: "Call Now",
    phone: "+1-800-306-0540",
  },
  {
    title: "E-mail : ",
    email: "info@fluxtechnologiesafrica.com",
  },
  {
    title: "Operating Hours : ",
    heading: "Sales Department",
    para1: "Monday - Saturday",
    para2: "8:00 am – 5:00 pm",
  },
  {
    title: "",
    heading: "Service Department",
    para1: "Monday - Friday",
    para2: "8:00 am – 5:00 pm",
  },
];

const Contact = () => {
  let Navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0);

}, [])

  return (
    <>
      <div className="boo">
        Contact
      </div>
      <div className="main_contact">
        <div className="detail_list">
          {detail.map((e, index) => {
            return (
              <>
                <div className="detail_content">
                  <div className="title">{e.title}</div>
                  {e.detail && <div className="para">{e.detail}</div>}
                  {e.phone && <div className="phone"><span>{e.phone}</span></div>}
                  {e.email && <div className="phone" onClick={() => window.open(`mailto:${e.email}`)}><span>{e.email}</span></div>}
                  {e.heading && <div className="heading">{e.heading}</div>}
                  {e.para1 && <div className="para">{e.para1}</div>}
                  {e.para2 && <div className="para">{e.para2}</div>}
                </div>
              </>
            );
          })}
        </div>

        <div className="input_list">
          {/* <div className="line">
            <span> I HAVE A QUESTION REGARDING...</span>
            <select>
              <option>Sales</option>
              <option>Investment or Stock</option>
              <option>Vendors or Suppliers</option>
              <option>Partnerships</option>
              <option>Distribution</option>
              <option>Events and Conference Requests</option>
              <option>Other</option>
            </select>
          </div> */}
          <div className="line">
            <span> First Name </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="John"
              autocomplete="off"
            />
          </div>
          <div className="line">
            <span> Last Name </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="Smith"
              autocomplete="off"
            />
          </div>
          <div className="line">
            <span> Email </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="jsmith@example.com"
              autocomplete="off"
            />
          </div>

          {/* <div className="line">
            <span> Country </span>
            <select>
              <option>United States</option>
              <option>Canada</option>
              <option>Australia</option>
              <option>Austria</option>
              <option>Belgium</option>
              <option>Brazil</option>
              <option>China</option>
              <option>Croatia</option>
              <option>Cyprus</option>
              <option>Czech Republic</option>
              <option>Denmark</option>
              <option>Egypt</option>
              <option>Estonia</option>
              <option>Finland</option>
              <option>France</option>
              <option>Georgia</option>
              <option>Germany</option>
              <option>Greece</option>
              <option>Greenland</option>
              <option>Hong Kong</option>
              <option>Hungary</option>
              <option>Iceland</option>
              <option>India</option>
              <option>Indonesia</option>
              <option>Ireland</option>
              <option>Israel</option>
              <option>Italy</option>
              <option>Japan</option>
              <option>Kazakhstan</option>
              <option>South Korea</option>
              <option>Latvia</option>
              <option>Liechtenstein</option>
              <option>Lithuania</option>
              <option>Luxembourg</option>
              <option>Macao</option>
              <option>Mexico</option>
              <option>Monaco</option>
              <option>Netherlands</option>
              <option>New Zealand</option>
              <option>Norway</option>
              <option>Poland</option>
              <option>Portugal</option>
              <option>Qatar</option>
              <option>Romania</option>
              <option>Russia</option>
              <option>Saudi Arabia</option>
              <option>Singapore</option>
              <option>Spain</option>
              <option>Sweden</option>
              <option>Switzerland</option>
              <option>Taiwan</option>
              <option>Turkey</option>
              <option>Ukraine</option>
              <option>United Arab Emirates</option>
              <option>United Kingdom</option>
            </select>
          </div>
          <div className="line">
            <span> Postal Code </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="12345-1234"
              autocomplete="off"
            />
          </div> */}

          <textarea className="area" />

          <div className="agree">
            <input type="checkbox" /><span>Join our mailing list for early access to product announcements, special events in your area, promotions, and more.</span>
          </div>
          <div className="btn">
            <button>Send Now</button>
          </div>
          <div className="copy">
            By submitting this form, you agree to our <span style={{cursor:"pointer"}} onClick={() => Navigate("/privacy")}> Privacy Policy</span>.
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
